import React, { useState, useRef } from 'react';
import { createPortal } from 'react-dom';

const PortalTooltip = ({ text, children, active = true, className = "relative w-full min-w-0", align = "center" }) => {
  const [show, setShow] = useState(false);
  const [coords, setCoords] = useState({ x: 0, y: 0 });
  const ref = useRef();

  const handleMouseEnter = () => {
    if (!active || !text) return;
    const rect = ref.current.getBoundingClientRect();
    setCoords({
      x: align === "left" ? rect.left : rect.left + rect.width / 2,
      y: rect.top
    });
    setShow(true);
  };

  const handleMouseLeave = () => {
    setShow(false);
  };

  return (
    <div 
      ref={ref} 
      onMouseEnter={handleMouseEnter} 
      onMouseLeave={handleMouseLeave} 
      className={className}
    >
      {children}
      {show && createPortal(
        <div 
          className="fixed z-[100000] pointer-events-none animate-in fade-in zoom-in-95 slide-in-from-bottom-1 duration-150"
          style={{ 
            left: coords.x, 
            top: coords.y, 
            transform: align === "left" ? 'translate(0%, -100%) translateY(-8px)' : 'translate(-50%, -100%) translateY(-8px)' 
          }}
        >
          <div className="bg-neutral-900 text-white text-[13px] py-2 px-3 rounded-lg shadow-2xl whitespace-nowrap border border-white/10 font-medium max-w-[400px] overflow-hidden text-ellipsis">
            {text}
          </div>
          <div className={`w-2 h-2 bg-neutral-900 rotate-45 absolute -bottom-1 border-r border-b border-white/10 ${align === "left" ? "left-4" : "left-1/2 -translate-x-1/2"}`}></div>
        </div>,
        document.body
      )}
    </div>
  );
};

export default PortalTooltip;
